import { useEffect, type ReactNode } from 'react';

interface PageHeaderProps {
  /** The page's name; also the browser title. */
  title: string;
  /** Live count shown after the title, e.g. the total matching rows. */
  count?: ReactNode;
  /** One line on what this page lists; shown as the title's tooltip. */
  description?: string;
  /** Toolbar controls, inline after the title. */
  children?: ReactNode;
  /** Right-aligned controls. */
  actions?: ReactNode;
}

/**
 * A page's pane header: eyebrow title, live count, its toolbar. The same
 * 40px band the scoring tool puts on every pane, so a list is anchored by what
 * it is and how much of it there is before the first control.
 */
export function PageHeader({
  title,
  count,
  description,
  children,
  actions,
}: PageHeaderProps) {
  useEffect(() => {
    document.title = `${title} · Hawk`;
  }, [title]);
  return (
    <div className="pane-header">
      <h1 className="pane-title" title={description}>
        {title}
        {count !== undefined && count !== null && <b>{count}</b>}
      </h1>
      {children}
      {actions && <div className="pane-actions">{actions}</div>}
    </div>
  );
}
